export default __webpack_public_path__ + "static/namebazaar-c4b986fff6f77e92685153e1f14ba5dc.jpg";